/* eslint-disable */
import $owlCarousel from 'owl.carousel';

export default class Slider {
    constructor() {
        this.$sliders = $('.slider');
    }

    loadSlider(slider) {
        const $slider = $(slider); 

        $slider.each(function(index) {
            const slider_name = $(this).data('slider');
            const items_number = $(this).data('slides');
            const items_margin = $(this).data('margin');
            const items_center = $(this).data('center') || false;

            const autoHeight = $(this).data('height') || false;
            const autoPlay = $(this).data('auto') || false;
            const dots = $(this).data('dots') || false;
            const drag = $(this).data('drag') || false;

            const nav = $(this).data('nav') || false;

            let navButtons = ['<i class="slider__arrow slider__arrow--left F-LONG-ARROW-LEFT"></i>', '<i class="slider__arrow slider__arrow--right F-LONG-ARROW-RIGHT"></i>']

            let subtract = 0;
            
            if(items_number >= 4) {
                subtract = 1;
            }

            let mobile_items = (items_number - (subtract*3));

            if(slider_name === 'products') {
                mobile_items = (items_number - (subtract*2));
            }

            if ($(this).hasClass('owl-thumbnails')) {
                $(this).owlCarousel({
                    loop: true,
                    items: 1,
                    slideSpeed: 2000,
                    dots: false,
                    nav: true,
                    navText: navButtons,
                    autoplay: autoPlay,
                    thumbs: true,
                    thumbImage: true,
                    thumbContainerClass: 'owl-thumbs',
                    thumbItemClass: 'owl-thumb-item'
                });
            } else {
                $(this).owlCarousel({
                    loop: true,
                    center: items_center,
                    margin: items_margin,
                    nav: nav,
                    navText: navButtons,
                    dots: dots,
                    mouseDrag: drag,
                    touchDrag: drag,
                    autoHeight: autoHeight,
                    autoplay: autoPlay,
                    autoplayTimeout: 4000,
                    autoplaySpeed: 2000,
                    autoplayHoverPause: true,
                    items: items_number,
                    responsive: {
                        0: {
                            items: 1,
                            margin: 0,
                        },
                        480: {
                            items: (items_number - (subtract)),
                            margin: items_margin - (items_margin / 2),
                        },
                        991: {
                            items: (items_number - (subtract)),
                            margin: items_margin,
                        },
                        1399: {
                            items: items_number,
                            margin: items_margin,
                        },
                        1599: {
                            items: items_number,
                            margin: items_margin,
                        }
                    },
                });
            }
        });
    }

    init() {
        this.loadSlider('.slider');
    }

    initThumbs() {
        this.loadSlider('.owl-thumbnails');
    }
}



// WEBPACK FOOTER //
// ./scripts/components/Slider.js